import axios from 'api/axios'
import { createContext, useState } from 'react'
import useFetchExpedientesMenu from '../hooks/useFetchExpedientesMenu'
import useFetchExpedientesUsuario from '../hooks/useFetchExpedientesUsuario'
import { deletePostedFile, uploadFile } from '../libs/FilesHelper'

let ExpedientesContext

const { Provider } = (ExpedientesContext = createContext())

const ExpedientesProvider = ({ children }) => {
  const tipos_expedientes = useFetchExpedientesMenu()
  const [current, setCurrent] = useState(null)
  const [iteration, setIteration] = useState(1)
  const [inicio, setInicio] = useState(0)
  const [mostrar, setMostrar] = useState(12)
  const [altaExpediente, setAltaExpediente] = useState(false)
  const [loadingCampos, setLoadingCampos] = useState(false)
  const [errorCampos, setErrorCampos] = useState('')
  const [campos_expediente, setCamposExpediente] = useState([])
  const [origen, setOrigen] = useState('')
  const expedientes_usuario = useFetchExpedientesUsuario(current, inicio, mostrar)
  const [uploadingFile, setUploadingFile] = useState(false)
  const [idProceso, setIdProceso] = useState(null)
  const [ficherosSubidos, setFicherosSubidos] = useState([])
  const [expedienteActual, setExpedienteActual] = useState(null)
  const [campos_origen, setCamposOrigen] = useState([])
  const [mensajeValidacion, setMensajeValidacion] = useState({
    tipo: '',
    texto: '',
    mostrar: false,
  })

  const regresar = () => {
    setAltaExpediente(false)
    setIdProceso(null)
    setFicherosSubidos([])

    switch (origen) {
      case 'menuExpedientes':
        setCurrent(null)
        setCamposExpediente([])
        setMostrar(12)
        break
      case 'listadoExpedientes':
        setOrigen('menuExpedientes') // seteamos como origen el menu para poder regresar desde el listado en caso de que vengamos de alli
    }
  }

  const forceRefresh = () => {
    setIteration(iteration + 1)
    setAltaExpediente(false)

    expedientes_usuario.refetchExpedientes(mostrar)

    if (current && current?.puede_consultar !== 'S') {
      regresar()
    }
  }

  const setCampoExpediente = (campo, valor, lanzar_validacion = false) => {
    // Actualiza el campo especifico en campos_expediente
    const updatedCampos = campos_expediente.map((c) => {
      if (c.columna === campo.columna) {
        return { ...c, valor: valor, error: '' }
      }
      return c
    })

    setCamposExpediente(updatedCampos)

    if (lanzar_validacion && valor) {
      validaCampoExpediente(campo, valor, updatedCampos)
    }
  }

  const setCampoError = (columna, error) => {
    const updatedCampos = campos_expediente.map((campo) => {
      if (campo.columna === columna) {
        return { ...campo, error: error }
      }
      return campo
    })

    setCamposExpediente((prev) => updatedCampos)
  }

  const setCampoCargando = (columna, cargando) => {
    const updatedCampos = campos_expediente.map((campo) => {
      if (campo.columna === columna) {
        return { ...campo, cargando: cargando }
      }
      return campo
    })

    setCamposExpediente((prev) => updatedCampos)
  }

  const resetCampoExpediente = (columna) => {
    const updatedCampos = campos_expediente.map((campo) => {
      if (campo.columna === columna) {
        return { ...campo, valor: '' }
      }
      return campo
    })

    setCamposExpediente(updatedCampos)
  }

  const validaCampoExpediente = (campo, valor, campos = []) => {
    const variables = []

    for (const campo of campos) {
      if (campo.columna !== 'TIPO_MENSAJE_WEB' && campo.columna !== 'MENSAJE_WEB') {
        variables.push({
          campo: campo.columna,
          valor: campo.valor ? campo.valor : '',
        })
      } else {
        variables.push({
          campo: campo.columna,
          valor: '',
        })
      }
    }

    const body = {
      programa: current.programa,
      campo: campo.columna,
      valor: valor,
      id_pers: current.id_pers,
      variables,
    }

    axios
      .post('expedienteslisa/validaCampoExpediente/', body)
      .then((responseValidacion) => {
        const campos_response = responseValidacion.data[0].campos
        if (
          Object.hasOwn(campos_response, 'tipo_mensaje_web') &&
          campos_response?.tipo_mensaje_web.valor !== 'error' &&
          Object.hasOwn(campos_response, 'mensaje_web') &&
          campos_response?.mensaje_web.valor
        ) {
          setMensajeValidacion((prev) => ({
            tipo: campos_response?.tipo_mensaje_web.valor,
            texto: campos_response?.mensaje_web.valor,
            mostrar: true,
          }))
        }

        const updatedCampos = campos.map((c) => {
          const clave = c.columna?.toLowerCase()
          if (campos_response && clave in campos_response) {
            return {
              ...c,
              valor: campos_response[clave].valor,
              cargando: false,
              error:
                Object.hasOwn(campos_response, 'tipo_mensaje_web') &&
                campos_response?.tipo_mensaje_web.valor === 'error'
                  ? campos_response?.mensaje_web.valor
                  : '',
            }
          }

          if (c.columna === campo.columna) {
            return {
              ...c,
              valor: valor,
              cargando: false,
              error:
                Object.hasOwn(campos_response, 'tipo_mensaje_web') &&
                campos_response?.tipo_mensaje_web.valor === 'error'
                  ? campos_response?.mensaje_web.valor
                  : '',
            }
          }

          return c
        })

        setCamposExpediente(updatedCampos)
      })
      .catch((errorValidacion) => {
        setCampoError(campo.columna, errorValidacion)
        setLoadingCampos(false)
      })
  }

  const enviarExpediente = async () => {
    const body = {
      datos: {
        id_personalizacion: current.id_pers,
        tipo_expediente: current.tipo_expediente,
        ficheros: [],
        id_proceso: idProceso,
      },
    }

    campos_expediente.forEach((campo) => {
      //Si el valor del campo es un array (lista de valores multiseleccion),
      // convertir el array en un string separado por comas
      if (campo.valor && Array.isArray(campo.valor)) {
        campo.valor = campo.valor.join(',')
      }
      body.datos[campo.columna.toLowerCase()] = campo.valor
    })

    const respuesta = await axios.post(`/expedienteslisa/`, body).finally(() => {
      // reiniciamos valor de los campos del formulario
      setCamposExpediente(campos_origen)
      setFicherosSubidos([])
      setIdProceso(null)
      setMostrar(12)
    })

    return respuesta
  }

  const subirFichero = async (file, tipo_documento, tipo_expediente) => {
    setUploadingFile(true)

    const response = await uploadFile(file, tipo_documento, tipo_expediente, idProceso)

    if (response) {
      setIdProceso(response.id_proceso)
      setFicherosSubidos(response.ficheros_list)
    }

    setUploadingFile(false)
  }

  const eliminarFichero = async (id_proceso, id_documento) => {
    setUploadingFile(true)

    const response = await deletePostedFile(id_proceso, id_documento)

    if (response) {
      setFicherosSubidos(response.ficheros_list)
    }

    setUploadingFile(false)
  }

  return (
    <Provider
      value={{
        tipos_expedientes,
        active: {
          current,
          setCurrent,
          forceRefresh,
        },
        campos_expediente,
        setCamposExpediente,
        setCamposOrigen,
        expedientes_usuario,
        inicio,
        setInicio,
        mostrar,
        setMostrar,
        altaExpediente,
        setAltaExpediente,
        loadingCampos,
        setLoadingCampos,
        errorCampos,
        setCampoExpediente,
        setCampoCargando,
        setCampoError,
        resetCampoExpediente,
        validaCampoExpediente,
        enviarExpediente,
        regresar,
        setOrigen,
        subirFichero,
        uploadingFile,
        idProceso,
        setIdProceso,
        ficherosSubidos,
        setFicherosSubidos,
        expedienteActual,
        setExpedienteActual,
        eliminarFichero,
        mensajeValidacion,
        setMensajeValidacion,
      }}
    >
      {children}
    </Provider>
  )
}

export { ExpedientesContext, ExpedientesProvider }
